import { Badge } from '@/components/ui/badge';
import { AlertCircle, AlertTriangle, Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { SystemEventLevel } from '@/hooks/useSystemEvents';

interface SystemEventLevelBadgeProps {
  level: SystemEventLevel;
  className?: string;
}

const levelConfig: Record<SystemEventLevel, {
  label: string;
  icon: typeof AlertCircle;
  className: string;
}> = {
  error: {
    label: 'Fel',
    icon: AlertCircle,
    className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
  warn: {
    label: 'Varning',
    icon: AlertTriangle,
    className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
  },
  info: {
    label: 'Info',
    icon: Info,
    className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  },
};

export function SystemEventLevelBadge({ level, className }: SystemEventLevelBadgeProps) {
  const config = levelConfig[level] || levelConfig.info;
  const Icon = config.icon;

  return (
    <Badge 
      variant="secondary"
      className={cn(
        'font-medium gap-1',
        config.className,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
